module.exports = __webpack_public_path__ + "img/rotatedevice.b886d1b2.svg";